import type { ThreadAnchorCursor } from "@/lib/states/global-state"

// The cursor next/prev walk from is captured when the thread opens. Answering a
// customer rewrites lastMessageAt, so a live cursor would resume from wherever
// the sort just moved the thread instead of the reader's place in the queue.
export const pinThreadCursor = (
	pinned: ThreadAnchorCursor | undefined,
	thread: ThreadAnchorCursor | undefined,
): ThreadAnchorCursor | undefined => {
	if (!thread) return pinned
	if (pinned?.id === thread.id) return pinned
	return {
		id: thread.id,
		lastStateChangeAt: thread.lastStateChangeAt,
		lastMessageAt: thread.lastMessageAt,
		createdAt: thread.createdAt,
		painLevel: thread.painLevel,
		snoozedUntil: thread.snoozedUntil,
	}
}
